export const mathRound = (num, ndecimals) => {
  // round to specified number of decimals
  // credit: https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
  return +(Math.round(num + `e+${ndecimals}`) + `e-${ndecimals}`)
}
